const doc = [({"en":({"js":({"admin":({"organizations":({"show":({"the_organization_was_deleted":"The organization was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;